import { HeroLine, Reveal } from "@/components/Motion";
import { EMAILS } from "@/lib/site";

const topics = [
  "The long search across traditions and what each tradition gave and did not give",
  "Why most spiritual memoirs feel false, and what an honest one would have to do",
  "Adi Shankara's Vivekachudamani and why a contemporary Indian reader might encounter it for the first time after exhausting Western options",
  "The cost of seeking — to marriage, to family, to ordinary life",
  "The difference between performed spirituality and the real thing",
  "Writing memoir without becoming a teacher, guide, or guru",
];

export default function PressPage() {
  return (
    <>
      <section data-testid="press-hero-section" className="min-h-[62svh] flex items-end pb-20 md:pb-28" style={{ backgroundColor: "var(--paper)" }}>
        <div className="max-w-[1100px] w-full mx-auto px-6 md:px-12">
          <p className="overline mb-6 animate-overline">Press</p>
          <h1 data-testid="press-title" className="font-serif-lit text-5xl sm:text-6xl leading-[1]" style={{ fontWeight: 500 }}>
            <HeroLine delay={0.12}>Press &amp;</HeroLine>
            <HeroLine delay={0.24} className="italic">Media</HeroLine>
          </h1>
          <p className="font-serif-lit text-lg md:text-xl leading-relaxed mt-8 max-w-2xl hero-copy-reveal" style={{ color: "var(--ink-soft)" }}>
            For interview requests, review copies, podcast bookings, and event inquiries:{" "}
            <a href={`mailto:${EMAILS.press}`} data-testid="press-email-link" className="literary-link" style={{ color: "var(--ink)" }}>{EMAILS.press}</a>
          </p>
        </div>
      </section>

      <section data-testid="press-copy-section" className="py-24 md:py-32" style={{ backgroundColor: "var(--paper-deep)" }}>
        <div className="max-w-[1100px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <Reveal>
            <p className="overline mb-7">About the book — copy-paste ready</p>
            <p className="font-serif-lit text-lg md:text-xl leading-[1.75]">
              <em className="italic">Nothing in the Way</em> is a debut memoir by Rahul Bhaskar about a twenty-year search across spiritual traditions — Christianity, Buddhism, Vipassana — and the eventual recognition that the search itself was the obstacle. Drawing on Adi Shankara's <em className="italic">Vivekachudamani</em>, the book is a contemporary, personal reading of an ancient non-dual teaching by someone who arrived at it by accident, after every other door had closed. It is available now on Amazon and Kindle.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="overline mb-7">About the author — copy-paste ready</p>
            <p className="font-serif-lit text-lg md:text-xl leading-[1.75]">
              Rahul Bhaskar is the author of <em className="italic">Nothing in the Way</em>. He spent decades moving between spiritual traditions before encountering the teaching that finally held. He lives in California with his family. <em className="italic">Nothing in the Way</em> is his first book.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="press-topics-section" className="py-24 md:py-32" style={{ backgroundColor: "var(--paper)" }}>
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline mb-8">Suggested interview topics</p>
            <p className="font-serif-lit text-lg md:text-xl leading-relaxed mb-10" style={{ color: "var(--ink-soft)" }}>The author is comfortable speaking on:</p>
          </Reveal>
          <ul className="press-topic-list" data-testid="press-topics-list">
            {topics.map((topic, index) => (
              <Reveal as="li" key={topic} className="press-topic-row" delay={index * 0.05}>
                <span className="manifesto-number">0{index + 1}</span>
                <span className="font-serif-lit text-xl md:text-2xl leading-relaxed">{topic}</span>
              </Reveal>
            ))}
          </ul>
          <Reveal>
            <p className="font-serif-lit italic text-base mt-12 max-w-2xl" style={{ color: "var(--ink-soft)" }}>
              The author does not give live demonstrations of meditation, lead retreats, or accept private students.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="press-contact-section" className="py-24 md:py-32" style={{ backgroundColor: "var(--ink)", color: "var(--paper)" }}>
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Reveal><p className="overline mb-8" style={{ color: "var(--warm)" }}>Press contact</p></Reveal>
          <Reveal delay={0.08}>
            <p className="font-serif-lit text-2xl md:text-4xl leading-[1.5]">
              For all bookings and inquiries, write to{" "}
              <a href={`mailto:${EMAILS.press}`} data-testid="press-contact-email" className="literary-link italic" style={{ color: "var(--paper)" }}>{EMAILS.press}</a>.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}